import { vsComponentName as userDetailRolesComponentName } from "./roles/component";
import {
  UserDetailTabsServiceProvider,
  vsProviderName as userDetailTabsServiceProviderName,
} from "./service";

userDetailTabsServiceConfig.$inject = [userDetailTabsServiceProviderName];
export function userDetailTabsServiceConfig(
  userDetailTabsServiceProvider: UserDetailTabsServiceProvider
) {
  userDetailTabsServiceProvider.addElement({
    id: "roles",
    displayName: "Roles",
    uiSrefFragment: "roles",
    stateDefinition: {
      url: "/roles",
      component: userDetailRolesComponentName,
      resolve: {},
    },
  });
}
